
























import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import { IBurnedFeesRes } from '@/store/modules/metrics/model'
@Component({
    components: {},
})
export default class Fees extends Vue {
    get prices(): any {
        return this.$store.state.prices
    }

    get inUSD() {
        const usd = this.prices?.usd
        return this.burnedFees.burned * usd
    }

    get burnedFees(): IBurnedFeesRes {
        return this.$root.$store.state.Metrics.burnedFees
    }
}
